
import Vue, { PropType } from "vue";
import CommonForm from "~/components/liveops-whitepaper/CommonForm.vue";
import { Block } from "~/domain/interfaces/BlockTypes";

export default Vue.extend({
  name: 'GlossaryHomepage',
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
  },

  data() {
    return {
    }
  },

  components: {
    CommonForm,
  },
})
